<template>
  <v-app>
    <v-container fluid grid-list-lg>
      <v-card>
        <v-toolbar>
          <v-icon>playlist_play</v-icon>
          <v-toolbar-title class="font-weight-light"
            >&nbsp;Bandeja de Solicitudes para Analizar</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                text
                icon
                color="red"
                v-on="on"
                @click="setStatusTareaFrecuente(action)"
              >
                <v-icon v-if="action.esFrecuente">favorite</v-icon>
                <v-icon v-else>favorite_border</v-icon>
              </v-btn>
            </template>
            <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
            <span v-else>Agregar a Tareas Frecuentes</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-layout row>
            <v-flex xs12 sm6 md3 lg3>
              <v-autocomplete
                v-model="filtro.sucursalId"
                :items="sucursales"
                item-text="nombre"
                item-value="id"
                label="Solicitudes de la Sucursal:"
                placeholder="Seleccione una"
                :menu-props="{ minWidth: '400' }"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md1 lg1 fluid v-if="muestraFiltroCanalesVenta">
              <v-checkbox
                v-model="cargaCanalesVenta"
                label="Filtrar Canales"
                :disabled="loading"
                @click="cargarCanalesVenta"
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 sm6 md3 lg3 v-if="cargaCanalesVenta">
              <v-autocomplete
                v-model="filtro.canalVentaId"
                :items="canalesVenta"
                item-text="nombre"
                item-value="id"
                label="Originadas en:"
                placeholder="Seleccione un Canal de Venta"
                :menu-props="{ minWidth: '400' }"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md3 l3>
              <v-autocomplete
                v-model="filtro.productoId"
                :items="productos"
                item-text="descripcion"
                item-value="id"
                label="Del producto:"
                placeholder="Seleccione uno"
                :menu-props="{ minWidth: '400' }"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md3 lg3>
              <app-selector-periodos
                v-on:update-periodo="filtro.periodo = $event"
                :column="true"
              ></app-selector-periodos>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6 md3 lg3>
              <v-text-field
                v-model="filtro.documento"
                label="Buscar por documento"
              >
              </v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md3 lg3>
              <v-select
                label="Analista:"
                v-model="filtro.analistaLogin"
                :items="analistas"
                item-text="login"
                item-value="login"
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md3 lg3>
              <v-select
                label="En estados:"
                v-model="filtro.subEstadoId"
                :items="subestados"
                item-text="descripcion"
                item-value="id"
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md3 lg3 fluid>
              <v-btn color="success" @click="getItems(true)" :disabled="loading"
                >Consultar</v-btn
              >
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex>
              <v-card>
                <v-toolbar dense :color="$store.state.UiColors.crudToolbarList">
                  <v-icon>list</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Lista</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                </v-toolbar>

                <v-data-table
                  dense
                  :headers="headers"
                  :items="records"
                  :server-items-length="totalItems"
                  :rows-per-page="pagination.rowsPerPage"
                  :options.sync="pagination"
                  v-model="selectedRow"
                  :loading="loading"
                  class="elevation-1"
                  :footer-props="footer"
                >
                  <template v-slot:no-data>
                    <v-alert
                      v-if="!primeraBusquedaRealizada"
                      :value="true"
                      color="grey lighten-3"
                      icon="info"
                    >
                      Ingrese los filtros para realizar la búsqueda
                    </v-alert>
                    <v-alert v-else :value="true" color="grey" icon="warning">
                      No se encontraron registros con los filtros ingresados
                    </v-alert>
                  </template>

                  <template v-slot:item="{ item }">
                    <tr>
                      <td>
                        <app-acciones-comunes
                          :personaId="item.solicitanteId"
                          :documento="item.cui.toString().substring(2, 10)"
                          :solicitudId="item.id"
                          :ocultarAnalisisConsulta="true"
                          :showCancelarAnalisis="
                            item.analista.includes('Tomado') &&
                              checkCanAccess('ap-forzar-cancelar-analisis')
                          "
                          @refrescar-lista="getItems(false)"
                        >
                        </app-acciones-comunes>
                      </td>

                      <td class="text-xs-left caption">
                        <tr>
                          {{
                            item.origen
                          }}
                        </tr>
                        <tr class="text-xs-left font-weight-light caption">
                          {{
                            item.producto
                          }}
                        </tr>
                      </td>

                      <td class="text-xs-left caption">
                        {{ item.planNombre }}
                      </td>
                      <td class="text-xs-left caption">{{ item.subEstado }}</td>

                      <td
                        class="text-xs-left caption"
                        v-if="
                          $store.state.parametrosGenerales
                            .ingresoPorDefectoPor == 'documento'
                        "
                      >
                        {{ item.documento }}
                      </td>
                      <td class="text-xs-left caption" v-else>
                        {{ item.cuil }}
                      </td>

                      <td class="text-xs-left caption">
                        {{ item.solicitante }}
                      </td>
                      <td class="text-xs-left caption">
                        {{ item.monto | currency }}
                      </td>
                      <td class="text-xs-left caption">{{ item.cuotas }}</td>
                      <td class="text-xs-left caption">
                        {{
                          item.fechaIngreso
                            | dateParse('YYYY-MM-DD')
                            | dateFormat('DD-MM-YYYY')
                        }}
                      </td>
                      <td class="text-xs-left caption">{{ item.analista }}</td>
                      <!-- <td class="text-xs-left caption" v-if="$store.state.parametrosGenerales.auditoriaLegajoFisico">{{ item.estadoLegajoOriginal }}</td> -->
                      <td
                        class="text-xs-left caption"
                        v-if="
                          $store.state.parametrosGenerales
                            .auditoriaLegajoDigital
                        "
                      >
                        {{ item.estadoValidacionDigital }}
                      </td>
                      <td class="text-xs-left caption">
                        {{ item.estadoValidacionTelefonica }}
                      </td>
                      <td class="text-xs-left caption">
                        {{ item.ultimasObservaciones }}
                      </td>
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              text
                              icon
                              v-on="on"
                              @click="imprimirDocumentacion(item)"
                            >
                              <v-icon>print</v-icon>
                            </v-btn>
                          </template>
                          Imprimir Documentación
                        </v-tooltip>
                      </td>
                      <td class="text-xs-left caption">
                        <v-chip small :color="item.empresaColor" label dark>{{
                          item.empresaShort
                        }}</v-chip>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
          <template v-if="$store.state.debugModeOn">
            Debug Info:
            <p></p>

            Model: {{ filtro }}
            <p></p>
          </template>
          <v-divider></v-divider>
        </v-card-text>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import { http } from '@/axios';
import Vue from 'vue';
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';
//import { format } from "date-fns";

export default {
  data() {
    return {
      primeraBusquedaRealizada: false,
      loading: false,
      editMode: false,
      suspend: false,
      filterChanged: false,
      search: '', // valor para búsqueda
      pagination: {
        // definición de paginación
        sortDesc: [true],
        sortBy: [''],
        page: 1,
        itemsPerPage: 5,
      },
      footer: {
        showFirstLastPage: true,
        itemsPerPageOptions: [5, 10, 20, 50],
      },
      totalItems: 0, // va afuera de pagination
      headers: [],
      records: [], // registros
      selectedRow: [],
      filtro: {
        sucursalId: 0,
        canalVentaId: 0,
        productoId: 0,
        subEstadoId: 0,
        analistaLogin: '(Todos)',
        periodo: { id: 1 },
      },
      canalesVenta: [],
      sucursales: [],
      productos: [],
      subestados: [],
      analistas: [],
      cargaCanalesVenta: false,
    };
  },
  async created() {
    // definición de columnas
    this.headers.push({
      text: 'Acciones',
      value: 'accion',
      width: 80,
      sortable: false,
    });
    this.headers.push({ text: 'Origen del Crédito', value: 'origen' });
    this.headers.push({ text: 'Plan', value: 'planNombre' });
    this.headers.push({ text: 'Estado', value: 'subestado' });

    if (
      this.$store.state.parametrosGenerales.ingresoPorDefectoPor == 'documento'
    )
      this.headers.push({ text: 'Documento', value: 'documento' });
    else this.headers.push({ text: 'Cuil', value: 'cuil' });

    this.headers.push({
      text: 'Solicitante del Crédito',
      value: 'solicitante',
    });
    this.headers.push({ text: 'Monto', value: 'monto', width: 120 });
    this.headers.push({ text: 'Cuotas', value: 'cuotas' });
    this.headers.push({ text: 'Fecha de Ingreso', value: 'fechaIngreso' });
    this.headers.push({ text: 'Analista', value: 'analista' });

    // if(this.$store.state.parametrosGenerales.auditoriaLegajoFisico)
    //   this.headers.push({ text: 'Legajo Físico', value: 'estadoLegajoOriginal',sortable:false });

    if (this.$store.state.parametrosGenerales.auditoriaLegajoDigital)
      this.headers.push({
        text: 'Legajo Digital',
        value: 'estadoValidacionDigital',
        sortable: false,
      });

    this.headers.push({
      text: 'Validación Telefónica',
      value: 'estadoValidacionTelefonica',
    });
    this.headers.push({
      text: 'Últimas Observaciones',
      value: 'ultimasObservaciones',
      sortable: false,
    });

    this.headers.push({ text: '', value: 'imprimir', sortable: false });
    this.headers.push({ text: 'Empresa', value: 'empresaNombre', width: 100 });

    this.loadSucursales();
    if(!this.$store.state.user.accesoTodosCanalesVenta){      
      this.cargarCanalesVenta();}
    else
      this.canalesVenta.push("(Todos)");

    this.loadProductos();
    this.loadSubEstados();
    this.loadAnalistas();
  },
  watch: {
    pagination: {
      handler() {
        if (this.primeraBusquedaRealizada) this.getItems(false);
      },
      deep: true,
    },
    search() {
      this.getItems(true);
    },
  },
  computed: {
    ...mapGetters(['getActionFromLink', 'error', 'user', 'checkCanAccess']),
    action: function() {
      return this.getActionFromLink(this.$route.path);
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'setActiveSubTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
      'setReporteActivo',
    ]),
    ...mapActions(['setStatusTareaFrecuente']),

    async cargarCanalesVenta() {      
      this.loadCanalesVenta();
      this.muestraFiltroCanalesVenta = false;
      this.cargaCanalesVenta = true;      

    },

    async getItems(resetPagination) {
      if (this.filtro.periodo.desde === undefined) {
        this.alertWarning('Debe elegir un periodo para la búsqueda.');
        return;
      }

      //Hago esto para que si cambias los filtros y tocas consultar traiga los resultados de la primera página
      if (resetPagination) {
        this.pagination.page = 1;
      }

      this.loading = true;
      this.$validator.reset();

      let filter = this.filtro;

      let idCanalesVenta = filter.canalVentaId.toString();

      //Si se eligió TODOS ( y no tiene acceso a todos los canaes) armo un string con todos los canales de venta habilitados para el usuario.
      if (
        filter.canalVentaId === 0 &&
        !this.$store.state.user.accesoTodosCanalesVenta
      ) {
        for (var i = 1; i < this.canalesVenta.length; i++) {
          if (i === 1) idCanalesVenta = this.canalesVenta[i].id;
          else idCanalesVenta += ',' + this.canalesVenta[i].id;
        }
      } else {
        idCanalesVenta = filter.canalVentaId;
      }

      try {
        var result = await http.get(
          'creditos/listcreditosaanalizar?sucursalId=' +
            filter.sucursalId +
            '&canalesVenta=' +
            idCanalesVenta +
            '&productoId=' +
            filter.productoId +
            '&subEstadoId=' +
            filter.subEstadoId +
            '&loginAnalista=' +
            filter.analistaLogin +
            '&documento=' +
            filter.documento +
            '&fechaDesde=' +
            filter.periodo.desde +
            '&fechaHasta=' +
            filter.periodo.hasta +
            '&limit=' +
            this.pagination.itemsPerPage +
            '&page=' +
            this.pagination.page +
            '&sortby=' +
            this.pagination.sortBy +
            '&descending=' +
            (this.pagination.sortDesc.length > 0
              ? this.pagination.sortDesc
              : 'false')
        );

        this.records = result.list;
        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.primeraBusquedaRealizada = true;
      this.loading = false;
    },
    async finAnalisis() {},
    async loadProductos() {
      this.loading = true;
      try {
        var result = await http.get('productos/');

        this.productos = result.list;

        this.productos.unshift({ id: 0, descripcion: '(Todos)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSucursales() {
      this.loading = true;
      try {
        var result = await http.get(
          'sucursales/list/porusuario?usuarioId=' + this.user.id
        );

        this.sucursales = result.list;

        this.sucursales.unshift({ id: 0, nombre: '(Todas)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCanalesVenta() {
      this.loading = true;
      try {
        var result = await http.get(
          'canalesventa/habilitadosparausuario?usuarioId=' + this.user.id
        );

        this.canalesVenta = result.list;

        this.canalesVenta.unshift({ id: 0, nombre: '(Todos)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSubEstados() {
      this.loading = true;
      try {
        var result = await http.get(
          'tipossubestadocredito?estadosParaAnalisisSolicitud=true'
        );

        this.subestados = result.list;

        this.subestados.unshift({ id: 0, descripcion: '(Todos)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadAnalistas() {
      this.loading = true;
      try {
        var result = await http.get('usuarios/listByRol?rolId=3'); //traigo los usuarios con rol analista

        this.analistas = result.list;

        this.analistas.unshift({
          id: '00000000-0000-0000-0000-000000000000',
          login: '(Todos)',
        });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    imprimirDocumentacion(item) {
      let params = [];
      params.push(item.id);
      Vue.$log.debug(params);
      this.setReporteActivo({
        reporte: 'Formulario Solicitud.trdp',
        params: params,
      });

      window.open('/reportes-test');
    },
  },
};
</script>
